import { jsx as _jsx } from "react/jsx-runtime";
import DrawingInspector from "../drawing/DrawingInspector";
import DrawingListPanel from "../drawing/DrawingListPanel";
import TemplateManagerPanel from "../drawing/TemplateManagerPanel";
export function buildDockObjectsContent(deps) {
    const { workspace, selected, t } = deps;
    if (!workspace) {
        return null;
    }
    const drawings = [...workspace.state.drawings];
    return (_jsx(DrawingListPanel, { drawings: drawings, selectedId: selected?.id ?? null, embedded: true, labels: {
            title: t("drawing.list.title"),
            empty: t("drawing.list.empty"),
            visible: t("drawing.list.visible"),
            hidden: t("drawing.list.hidden"),
            locked: t("drawing.list.locked"),
            unlocked: t("drawing.list.unlocked"),
            selected: t("drawing.list.selected"),
            delete: t("drawing.list.delete"),
        }, onSelect: (id) => workspace.selectDrawing(id), onToggleVisible: (id) => {
            const d = drawings.find((x) => x.id === id);
            if (d) {
                workspace.interaction.updateDrawing(id, { visible: d.visible === false });
            }
        }, onToggleLocked: (id) => {
            const d = drawings.find((x) => x.id === id);
            if (d) {
                workspace.interaction.updateDrawing(id, { locked: !d.locked });
            }
        }, onDelete: (id) => {
            const nextDrawings = workspace.interaction.allDrawings.filter((x) => x.id !== id);
            workspace.interaction.replaceDrawings(nextDrawings);
            if (selected?.id === id) {
                workspace.selectDrawing(null);
            }
        }, onRename: (id, label) => {
            workspace.interaction.updateDrawing(id, { label });
        }, onBringToFront: (id) => {
            const maxZ = workspace.interaction.allDrawings.reduce((m, x) => Math.max(m, x.zIndex ?? 0), 0);
            workspace.interaction.updateDrawing(id, { zIndex: maxZ + 1 });
        }, onSendToBack: (id) => {
            const minZ = workspace.interaction.allDrawings.reduce((m, x) => Math.min(m, x.zIndex ?? 0), 0);
            workspace.interaction.updateDrawing(id, { zIndex: minZ - 1 });
        }, bringToFrontLabel: t("drawing.bringToFront"), sendToBackLabel: t("drawing.sendToBack") }));
}
export function buildDockPropertiesContent(deps) {
    const { workspace, selected, t, textEdit, actions } = deps;
    if (!selected || !workspace) {
        return _jsx("div", { className: "vnsc-drawing-dock__empty", children: t("drawing.dock.emptyProperties") ?? "No object selected" });
    }
    return (_jsx(DrawingInspector, { drawing: selected, embedded: true, labels: {
            title: t("drawing.dockProperties"),
            stroke: t("drawing.stroke"),
            selectIcon: t("drawing.selectIcon"),
            iconSize: t("drawing.iconSize"),
            fill: t("drawing.fill"),
            strokeWidth: t("drawing.strokeWidth"),
            lineStyle: t("drawing.lineStyle"),
            opacity: t("drawing.opacity"),
            solid: t("drawing.solid"),
            dashed: t("drawing.dashed"),
            dotted: t("drawing.dotted"),
            lock: t("drawing.lock"),
            unlock: t("drawing.unlock"),
            clone: t("drawing.clone"),
            hide: t("drawing.hide"),
            show: t("drawing.show"),
            bringToFront: t("drawing.bringToFront"),
            sendToBack: t("drawing.sendToBack"),
            delete: t("drawing.delete"),
            close: t("drawing.close"),
        }, textEditor: ["text", "callout", "priceLabel"].includes(selected.type) ? {
            active: textEdit.isEditingText,
            value: textEdit.drawingTextDraft,
            labels: {
                title: t("drawing.textEditorTitle"),
                label: t("drawing.textEditorLabel"),
                placeholder: t("drawing.textEditorPlaceholder"),
                edit: t("drawing.textEditorEdit"),
                save: t("drawing.textEditorSave"),
                cancel: t("drawing.textEditorCancel"),
                empty: t("drawing.textEditorEmpty"),
            },
            onChange: textEdit.setDrawingTextDraft,
            onStartEdit: () => textEdit.onStartTextEdit(selected?.text ?? ""),
            onCommit: () => textEdit.onCommitTextEdit((draft) => {
                workspace.interaction.updateDrawing(selected.id, { text: draft });
            }),
            onCancel: textEdit.onCancelTextEdit,
        } : undefined, onUpdate: (patch) => workspace?.interaction.updateDrawing(selected.id, patch), onDelete: actions.onDeleteDrawing, onClone: actions.onCloneSelected, onToggleLock: actions.onToggleSelectedLock, onToggleVisible: actions.onToggleSelectedVisibility, onBringToFront: actions.onBringSelectedToFront, onSendToBack: actions.onSendSelectedToBack, onClose: () => workspace?.selectDrawing(null) }));
}
export function buildDockTemplatesContent(deps) {
    const { workspace, selected, t } = deps;
    if (!selected) {
        return _jsx("div", { className: "vnsc-drawing-dock__empty", children: t("drawing.dock.emptyTemplates") });
    }
    return (_jsx(TemplateManagerPanel, { drawingType: selected.type, drawing: selected, locked: selected.locked, onUpdate: (patch) => workspace?.interaction.updateDrawing(selected.id, patch), labels: {
            loadTemplate: t("drawing.templatesLoad"),
            saveAs: t("drawing.templatesSave"),
            load: t("drawing.templatesLoad"),
            save: t("drawing.templatesSave"),
            delete: t("drawing.templatesDelete"),
            namePlaceholder: t("drawing.templatesNamePlaceholder"),
        } }));
}
